import { Component, Vue } from 'vue-property-decorator';
import { environment } from '@/helpers/Environment';
import { formatRecentOrders, getMyOrders } from '@/helpers/OrderSessionHelpers';
@Component({})
export default class RecentOrdersRoute extends Vue {
    loading = false;
    orders = null;
    // TODO: Remove these config options once we have confidence in this in production
    enabled = environment.config.my_account_pages?.recent_orders ?? false;
    created() {
        this.loading = true;
        getMyOrders()
            .then((data) => {
            if (!data)
                return;
            const { orders, venues, templates } = data;
            this.orders = formatRecentOrders(orders, venues, templates);
        })
            .finally(() => (this.loading = false));
    }
}
